
<div v-if="protocol" class="w-100 pa-1 lm-border ">
    <d-unit-select-dialog
        v-model      = "showUnitSelect"
        :title       = "$t('todo.guard.assign.title')"
        :text        = "$t('todo.guard.assign.text')"
        :store-label = "$t('todo.guard.assign.label')"
        :customer    = "{
            id: protocol.customerId
        }"
        @selected    = "onSelected"
    />

    <div class="pa-1" >
        <div class="v-flex">
            <div class="text-primary">
                {{ protocol.factoryNo }}
            </div>
            <v-spacer />
            <div class="">
                {{ formatDate (protocol.inspectionDate) }}
            </div>

            <div style="margin-top: 0" class="v-flex">
                <p-inc-guard-protocol-check-list
                    class     = "pl-2"
                    :protocol = "protocol"
                    :valid    = "protocol.result === 'ok'"
                />
                <c-toolbar-button
                    v-if="!protocol.unit && protocol.customerId"
                    icon    = "mdi-connection"
                    size    = "18"
                    color   = "primary"
                    tooltip = "Anlage zuordnen"
                    @click  = "onAssign"
                />
                <c-toolbar-button
                    icon    = "mdi-delete"
                    size    = "22"
                    color   = "error"
                    tooltip = "Protokoll löschen"
                    @click  = "onDelete"
                />
            </div>
        </div>
        <div style="font-size: 12px">
            {{ protocol.street }}, {{ protocol.city }}
        </div>

        <div class="v-flex">
            <div
                v-if="!protocol.unit && protocol.customerId"
                class="error--text"
                style="font-size: 12px"
            >
                unbekannte Anlage
            </div>
            <div
                v-if="!protocol.unit && !protocol.customerId"
                class="error--text"
                style="font-size: 12px"
            >
                unbekannter Kunde
            </div>
            <v-spacer />
            <div
                style="font-size: 12px"
            >
                {{ protocol.customerName }}
            </div>
        </div>
    </div>
</div>
